export const SUBDOMAIN_CONFIG = {
    'apa-pr-desk': {
        isGrey: true,
        title: 'Speech-to-Text',
        subtitle: 'PR-DESK by APA-Comm',
        colors: {
            headerBgColor: '#f06900',
            headerColor: 'white',
        },
        logoName: 'apa',
    },
    'apa-vod': {
        isGrey: true,
        title: 'VOD',
        subtitle: 'by APA-Comm',
        colors: {
            headerBgColor: '#085c7c',
            headerColor: 'white',
        },
        logoName: 'apa',
    },
};
const getSubdomain = () => {
    const { hostname } = window.location;
    const parts = hostname.split('.');
    if (parts.length > 2) {
        return parts[0];
    }
    return null;
};
export const getSubdomainConfig = () => {
    const subdomain = getSubdomain();
    return (subdomain !== null ? SUBDOMAIN_CONFIG[subdomain] : undefined);
};
